import React from "react";
import logo from "../logo.png";
import userLogo from "../user.png";

const SideBar = () => {
  let user = true;

  return (
    <div className="col-sm-auto px-sm-2 px-0 w-auto" data-bs-theme="dark">
      <div className="d-flex flex-column align-items-center px-md-3 px-sm-2 pt-2 text-white min-vh-100">
        <a
          href="/"
          className="d-flex align-items-center mb-md-0 py-2 text-white text-decoration-none"
        >
          <img src={logo} alt="carrot-logo" style={{ width: "100px" }} />
        </a>
        <p
          className="d-sm-inline text-center mb-5"
          style={{
            width: "100px",
            fontFamily: "Monotype Corsiva",
          }}
        >
          your need is always possible
        </p>
        {/* if user */}
        <img
          src={userLogo}
          alt="hugenerd"
          width="50"
          height="50"
          className="rounded-circle"
        />
        <p
          className="d-sm-inline text-center mb-5"
          style={{
            width: "100px",
          }}
        >
          Ronza Hany
        </p>
        <ul
          className="nav nav-pills flex-column mb-sm-auto mb-0 align-items-center"
          id="menu"
        >
          <li className="nav-item mb-3">
            <a href="#" className="nav-link align-middle px-0 text-white">
              <i className="bi bi-house-door fs-3"></i>
            </a>
          </li>
          <li className="mb-3">
            <a href="#" className="nav-link align-middle px-0 text-white">
              <i className="bi bi-person-circle fs-3"></i>
            </a>
          </li>
          <li className="mb-3">
            <a href="#" className="nav-link align-middle px-0 text-white">
              <i className="bi bi-bell fs-3"></i>
            </a>
          </li>
          <li className="mb-3">
            <a href="#" className="nav-link align-middle px-0 text-white">
              <i className="bi bi-gem fs-3"></i>
            </a>
          </li>
          <li className="mb-3">
            <a href="#" className="nav-link align-middle px-0 text-white">
              <i className="bi bi-chat-left fs-3"></i>
            </a>
          </li>
          <li className="mb-3">
            <a href="#" className="nav-link align-middle px-0 text-white">
              <i className="bi bi-person fs-3"></i>
            </a>
          </li>
        </ul>
        <hr />
        <div className="pb-4 mb-5">
          <a
            href="#"
            className="d-flex align-items-center text-white text-decoration-none"
          >
            <i className="bi bi-box-arrow-right fs-3"></i>
          </a>
        </div>
      </div>
    </div>
  );
};

export default SideBar;
